<tidy-wrapper>
  <div class="update-required">
    <img class="logo" src="assets/img/tidy-logo.svg" alt="TIDY" />
    <tidy-text [title]="'Please update the TIDY app'" />
    <tidy-text [body]="'This version of TIDY is no longer supported. Update to the latest version to keep using the app.'" />
    <tidy-button
      [text]="'Update TIDY'"
      [action]="openStore"
      class="primary full-width" />
  </div>
</tidy-wrapper>
